import utils from '@/_modules/utils';
import {gsap, Quart} from 'gsap/all';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

class _eventContent {
  //constructor() {}

  once() {
    this.adjust = 0;

    // セミナー内容アンカー
    const anchorSeminar = document.querySelectorAll('#c-seminarTable a');
    if (anchorSeminar.length > 0) {
      anchorSeminar.forEach((el, i) => {
        console.log(el.hash.replace('#', ''));
        el.addEventListener('click', this.clickAnchor.bind(this, el.hash.replace('#', '')));
      });
    }

    // iframeレスポンシブ
    const iframes = document.querySelectorAll('.c-content iframe');
    if (iframes.length > 0) {
      iframes.forEach((el, i) => {
        el.parentNode.classList.add('is-responsive-iframe');
      });
    }
  }

  clickAnchor(id, e) {
    if (e) e.preventDefault();
    this.gotoAnchor(id);
  }
  
  gotoAnchor(id) {
    const target = document.querySelector(`#${id}`);
    if (target) {
      const offset = utils.getOffsetTop(target);
      gsap.to(window, {
        duration: 0.7,
        scrollTo: {
          y: offset.top - this.adjust,
          autoKill: false,
        },
        ease: Quart.easeOut
      });
    }
  }

  resize() {
    if (utils.getMatchMedia()) {
      this.adjust = (100 / 750) * window.innerWidth;
    } else {
      this.adjust = 140;
    }
  }
}

const eventContent = new _eventContent();

export default eventContent;